export default __webpack_public_path__ + "static/media/goshen68.71d3fe2a.jpg";